export default {
  namespaced: true,
  state: {
    commentList: []
  },
  mutations: {
    SET_CACHE_COMMENT(state, commentList) {
      state.commentList = commentList
    }
  },
  actions: {
    set_cache_comment_list({commit}, commentList) {
      let timer = setTimeout(() => {
        commit('SET_CACHE_COMMENT', commentList)
        clearTimeout(timer)
      }, 0)
    }
  },
  getters: {
    cacheArticleHtml: state => typeof state.cacheArticle === 'object' ? state.cacheArticle.html : ''
  }
}